import classnames from "classnames";
import React from "react";

import { RichTextBlock, Slice } from "../components";
import { ISliceHeader } from "../types";

export const Header = ({
  slice_type,
  primary,
  items,
}: ISliceHeader): JSX.Element | null => {
  const {
    title_h1: title,
    title_h2: subtitle,
    class_name: className,
    background_color: backgroundColor,
    background_image: backgroundImage,
  } = primary;

  const isEmpty = title?.length === 0 && subtitle?.length === 0;

  if (isEmpty) {
    return null;
  }

  const hasItems =
    items.filter(({ header_rich_text }) => {
      return header_rich_text.length > 0;
    }).length > 0;

  return (
    <Slice
      className={classnames("slice-header", className)}
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
      as="header"
    >
      <RichTextBlock className="block-h1" render={title} />
      <RichTextBlock className="block-h2" render={subtitle} />

      {hasItems && (
        <div className="header-items">
          {items.map(({ header_rich_text }, i: number) => (
            <RichTextBlock
              className="header-item-text"
              render={header_rich_text}
              key={i}
            />
          ))}
        </div>
      )}
    </Slice>
  );
};
